module.exports = __webpack_public_path__ + "img/dianzimingpian.ba039705.png";